module.exports = __webpack_public_path__ + "media/images/icons/outlined/wallet-1d8fc0df12b46116f99a3905dec33529.svg";